// extracted by mini-css-extract-plugin
export default {"about":"About_about__tFYRZ","appear":"About_appear__IVhFV","about-message":"About_about-message__upgCk","message":"About_message__98fNT","roll-up":"About_roll-up__4MvEb"};